/* RESPONSIBLE TEAM: team-actions */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';

// `Transition#intent.url` is private Ember API. The widened type lets us read
// the original URL the user navigated to. The `!url` fallback below protects
// against future Ember versions removing the field — in that case we degrade
// to the index of custom-actions instead of crashing.
type TransitionWithIntent = Transition & { intent: { url: string | null } };

export default class DataConnectorsRedirectRoute extends Route {
  @service declare router: RouterService;

  beforeModel(transition: TransitionWithIntent) {
    let url = transition.intent.url;
    if (!url) {
      this.router.replaceWith('apps.app.settings.app-settings.custom-actions');
      return;
    }
    // Anchor the rewrite to the pathname so the legacy substring isn't rewritten
    // if it happens to appear inside a query param value or hash fragment.
    let parsed = new URL(url, window.location.origin);
    parsed.pathname = parsed.pathname.replace(
      /\/settings\/app-settings\/data-connectors(?=\/|$)/,
      '/settings/app-settings/custom-actions',
    );
    this.router.replaceWith(`${parsed.pathname}${parsed.search}${parsed.hash}`);
  }
}
